<template>
  <template v-if="isBlur">
    <li class="clickable">
      <div class="blur">
        <div class="content">COMING SOON</div>
      </div>
      <span class="info">CMS</span>
      <span class="info">CMS</span>
      <b>COMING SOON<span>W</span></b>
      <a :href="detailLink" style="color:#53D2E3">Who's Next</a>
      <span class="num">지금 <span style="font-weight: bold">999</span>명 이용중</span>
    </li>
  </template>
  <template v-else>
    <li @click="routerDetail()" class="clickable">
      <span class="info" v-for="tag in tags" :key="tag">{{ tag }}</span>
      <b>{{ title }}<span>{{ subTitle }}</span></b>
      <a :href="detailLink" style="color:#53D2E3">Read more</a>
      <span class="num">지금 <span style="font-weight: bold">{{ userCount }}</span>명 이용중</span>
    </li>
  </template>
</template>

<script>
export default {
  name: "MemberShipTrainingCard",
  props: ["title", "subTitle", "tags", "userCount", "code", "isBlur"],
  methods: {
    routerDetail() {
      this.$router.push(this.detailLink)
    }
  },
  computed: {
    detailLink() {
      return '/training/' + this.code;
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.blur {
  border-radius: 18px;
  z-index: 999;
  background: rgba(58, 57, 61, 0.5);
  backdrop-filter: blur(5px);
  display: table;

  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.blur .content {
  height:inherit;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
}

</style>
